import {
  Component,
  HostListener,
  OnDestroy,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule, Location } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../services/auth.service';
import { Router, RouterModule } from '@angular/router';
// import { BreadcrumbService } from '../services/breadcrumb.service';
import { EmployeeService } from '../../features/employees/employee.service';
import { map, Subscription } from 'rxjs';
import { BreadcrumbService } from '../services/breadcrumb.service';
import { BranchService } from '../../features/branch/services/branch.service';
import { ImageService } from '../../shared/services/image.service';
import { SidePopupComponent } from "../../shared/components/side-popup/side-popup.component";
import { selectNotifications } from '../notifications/notification.selector';
import { Store } from '@ngrx/store';
// import { BranchService } from '../../features/branch/services/branch.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    RouterModule,
    SidePopupComponent
],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy, OnInit {
  form = new FormGroup({
    selectedOption: new FormControl('option2'), // Default value
  });
  branchForm: FormGroup

  branches = [
    { value: 'option1', viewValue: 'Creative Spaces' },
    { value: 'option2', viewValue: 'Artisan Interiors' },
    { value: 'option3', viewValue: 'Elysian Designs' },
    { value: 'option4', viewValue: 'Luxury Spaces' },
  ];

  isDropdownOpen = false;
  breadcrumbs: Array<any> = [];
  loggedInUser: any;
  userId: number;
  userData: any;
  profilePicture: any;
  private subscriptions: Subscription = new Subscription();
  public branchData: any[] = [];

  @Input() sidebarData: any;
  branchId: any;
  isSidebarOpen = false;
  notificationCount$: any;

  constructor(
    private elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private employeeService: EmployeeService,
    private imageService: ImageService,
    private fb: FormBuilder,
    private branchService: BranchService,
    private store: Store,
  ) {

  }

  ngOnInit() {
    this.initForm();
    this.loadBranches();
    this.breadcrumbs = this.breadcrumbService.getBreadcrumbs();
    this.loggedInUser = this.authService.getLoggedInUser();
    const loggedInUser = this.authService.getLoggedInUser();
    this.userId = loggedInUser?.employeeData?.id;
    this.userData = {
      firstName: loggedInUser?.employeeData?.firstName,
      lastName: loggedInUser?.employeeData?.lastName,
      designation: loggedInUser?.employeeData?.designation,
    };
    this.notificationCount$ = this.store
    .select(selectNotifications)
    .pipe(map(notifications => notifications.length));
  
    // Subscribe to the employee data
    // this.subscriptions.add(
    //   this.employeeService
    //     .getEmployeeById(this.userId)
    //     .subscribe(async (data) => {
    //       try {
    //         this.userData = data;

    //         let profilePicturePromise;

    //         if (this.userData.profilePicture) {
    //           profilePicturePromise = this.imageService
    //             .getImageAsBase64(this.userData.profilePicture)
    //             .catch((error) => {
    //               console.error('Error loading profile picture:', error);
    //               return 'assets/images/dummy-profile-image.jpg';
    //             });
    //         } else {
    //           profilePicturePromise = Promise.resolve(
    //             'assets/images/dummy-profile-image.jpg'
    //           );
    //         }

    //         const [profilePicture] = await Promise.all([profilePicturePromise]);
    //         this.profilePicture = profilePicture;
    //       } catch (error) {
    //         console.error('Error loading employee data:', error);
    //       }
    //     })
    // );
  }

  private initForm(): void {
    const selectedBranchId: any = localStorage.getItem('selectedBranchId');
      const branch = JSON.parse(selectedBranchId);
      this.branchId = branch;
      this.branchForm = this.fb.group({
        branchName: [this.branchId || 0],
      });
      this.branchForm.get('branchName')?.valueChanges.subscribe((selectedBranchId) => {
        if (!this.branchId || this.branchId !== selectedBranchId) {
          localStorage.setItem('selectedBranchId', selectedBranchId);
    
          // Force reload route (no full browser reload)
          const currentUrl = this.router.url;
          const firstSegment = currentUrl.split('/')[1];
          window.location.href = `/${firstSegment}`;
        }
      });
  }

  private loadBranches() {
    this.branchService.fetchBranches().subscribe({
      next: (branches) => {
        this.branchData = branches;
        this.setDefaultBranch();

      },
      error: (error) => console.error(error),
    });
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  private setDefaultBranch() {
    const selectedBranchId = localStorage.getItem('selectedBranchId');
    console.log('selectedBranchId',selectedBranchId);
    
    // If there's no saved branch ID and we have branches, select the first one
    if (!selectedBranchId && this.branchData.length > 0) {  
      const firstBranchId = this.branchData[0].id;
      this.branchForm.patchValue(
        { branchName: firstBranchId },
        { emitEvent: false }
      );
      // Optionally save it to localStorage
      localStorage.setItem('selectedBranchId', firstBranchId);
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  handleDropdownClick(event: MouseEvent) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
    this.router.navigate([`/my-profile/${this.userId}`]);
  }

  logout() {
    this.authService.logout();
    // this.router.navigate(['/login']);
    // window.location.reload();
  }

  notificationRoute() {
    this.router.navigate(['/notifications']);
  }

  // Updated goBack method to use router navigation
  goBack(): void {
    if (this.breadcrumbs.length > 1) {
      const previousBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 2];
      this.router.navigate([previousBreadcrumb.path]);
    }
  }

  // Helper method to determine if the back button should be shown
  shouldShowBackButton(): boolean {
    return this.breadcrumbs.length > 1; // Show back button only if there's more than one breadcrumb
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
